<template>
  <article>
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg font-medium leading-6 text-gray-900">
        Coworker*innen
      </h3>
    </div>
    <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
      <MembershipList :podcast="podcast" />
    </div>
  </article>
  <article>
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg font-medium leading-6 text-gray-900">
        Einladungen
      </h3>
    </div>
    <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
      <InvitationList :podcast="podcast" />
    </div>
  </article>
  <FormButtons>
    <div class="space-x-2">
      <BackButton />
      <SubmitButton @click="invite">
        Coworker*innen einladen
      </SubmitButton>
    </div>
  </FormButtons>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const router = useRouter();
const store = useStore();
const podcast = computed(() => store.getters['context/context']);

const invite = () => router.push({name: 'podcasts.invite', params: {id: podcast.value.id} });
</script>
